export enum InspectionFinishCategory {
  Deleted = "5",
  Pending = "4",
  NotRequired = "3",
  Other = "2",
  AlreadyExists = "1",
  Completed = "6",
}
